module.exports = __webpack_public_path__ + "img/housingAccumulaton.2ba632f5.png";